export const globalPinnedBarWidth = 260;
